import React, { Dispatch, useMemo } from 'react';

import Location from '@r6digital/rapidstor-types/react/entities/Location';
import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';

import { formatCurrency, formatPriceLabel } from '@/core/utils/currency';

import classes from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLElement> {
    option: UnitType;
    initialRate?: number;
    location: Location;
    selected: boolean;
    default?: boolean;
    showTotalPrice?: boolean;
    setDefaultUnitType?: () => void;
    setSelectedID: Dispatch<React.SetStateAction<string>>;
}

export default function MapOption({
    option,
    initialRate,
    location,
    selected,
    default: defaultOption,
    showTotalPrice,
    setDefaultUnitType,
    setSelectedID,
}: Props) {
    const priceDifferenceDisplay = useMemo(() => {
        const optionRate = option.rates.rate;

        const priceDifference = optionRate - (initialRate ?? 0);

        if (defaultOption) {
            return formatPriceLabel(formatCurrency(optionRate, location), location);
        }

        if (showTotalPrice) {
            return formatPriceLabel(formatCurrency(optionRate, location), location);
        }

        if (priceDifference === 0) {
            return formatPriceLabel(formatCurrency(optionRate, location), location, false, false);
        }

        if (priceDifference > 0) {
            return `+${formatPriceLabel(formatCurrency(priceDifference ?? 0, location), location, false, false)}`;
        }
        return `-${formatPriceLabel(formatCurrency(Math.abs(priceDifference ?? 0), location), location, false, false)}`;
    }, [
        defaultOption,
        initialRate,
        location,
        option.rates.rate,
        showTotalPrice,
    ]);

    return (
        <div className={`${classes.map}`}>
            <div className={`${classes.first}`}>
                <div className={`${classes.opt_in}`}>
                    <div className={`${classes.custom_checkbox}`}>
                        <input
                            id={option._id}
                            type="checkbox"
                            checked={!!selected}
                            onChange={() => {
                                if (selected) {
                                    setDefaultUnitType?.();
                                } else {
                                    setSelectedID(option._id);
                                }
                            }}
                        />
                        <label
                            htmlFor={option._id}
                            className={`${classes.label}`}
                        />
                    </div>
                    <div className={`${classes.upsell_description}`}>
                        <span className={`${classes.name}`}>{option.typeName}</span>
                    </div>
                </div>
            </div>
            <div className={`${classes.last}`}>
                <span className={`${classes.price}`}>{priceDifferenceDisplay}</span>
            </div>
        </div>
    );
}
